import execService from '../exec';

/**
 * 判断是否是对象
 */
function isObject(value) {
  return Object.prototype.toString.call(value).toLowerCase() === '[object object]';
}

class Report {
  constructor() {
    this.apiPrefix = 'common.report';

    this.apis = {
      dataWarehouseSend: `${this.apiPrefix}.dataWarehouseSend`
    };
  }

  /**
   * 数仓上报发送
   * @param {*} eventName 事件名
   * @param {*} data 上报数据 格式eg：{userId: 'xxx', version: 'xxx'}
   */
  dataWarehouseSend(eventName, data) {
    // 格式转换: {userId: 'xxx', version: 'xxx'} => [{attribute: 'userId', value: 'xxxx'}, {attribute: 'version', value: 'xxxx'}]
    let content = [];

    if (isObject(data)) {
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          content.push({attribute: key, value: data[key]});
        }
      }
    }

    execService.exec(this.apis.dataWarehouseSend, {eventName, content});
  }
}

export default new Report();



// WEBPACK FOOTER //
// ./src/lib/client-api/report/index.js